module.exports = __webpack_public_path__ + "static/img/4.ee69df1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/6/1/zh/4.png
// module id = Xxj4
// module chunks = 0